import { z } from "zod";

export const stepContentSchema = z.object({
    stepName: z.string().nullish(),
    title: z.string().nullish(),
    content: z.string().nullish(),
});

export const cmsImageSchema = z.object({
    url: z.string().nullish(),
    alt: z.string().nullish(),
});

export const helpVideoSchema = z.object({
    youtubeUrl: z.string().nullish(),
    title: z.string().nullish(),
    description: z.string().nullish(),
});

export const videosSectionSchema = z.object({
    title: z.string().nullish(),
    description: z.string().nullish(),
    videos: z.array(helpVideoSchema).nullish(),
});

export const decorationTypeStepContentSchema = z.object({
    stepName: z.string().nullish(),
    title: z.string().nullish(),
    content: z.string().nullish(),
    windowDecorationDescription: z.string().nullish(),
    sunProtectionDescription: z.string().nullish(),
    windowDecorationImage: cmsImageSchema.nullish(),
    sunProtectionImage: cmsImageSchema.nullish(),
    videosSection: videosSectionSchema
        .nullish()
        .catch(undefined)
        .transform((value) => value ?? {}),
});

export const settingsSchema = z.object({
    nextButtonText: z.string().nullish(),
    finishOrderButtonText: z.string().nullish(),
    phoneNumber: z.string().nullish(),
    pricesIncludeVat: z.boolean().nullish(),
    windowDressingStep: stepContentSchema.nullish(),
    productSelectionStep: stepContentSchema.nullish(),
    colorsStep: stepContentSchema.nullish(),
    overviewStep: stepContentSchema.nullish(),
    decorationTypeStep: decorationTypeStepContentSchema.nullish(),
});

export const settingsResponseSchema = z.object({
    GlobalSetting: settingsSchema,
});
